<template lang="pug">
.maintenance-page
  v-container.fill-height
    v-row(align="center" justify="center")
      v-col(cols="12" sm="8" md="6")
        v-card.pa-6.text-center.maintenance-card(elevation="10")
          v-img.mx-auto.mb-6(
            src="/img/logo-primary.svg"
            max-width="200"
            contain
          )
          
          h1.text-h4.font-weight-bold.primary--text.mb-6 Sitio en Mantenimiento
          
          p.text-body-1.mb-8
            | Estamos realizando mejoras en nuestro sitio.
            br
            | Volveremos pronto con novedades.
          
          v-form.mt-6(v-if="!hasAccess" @submit.prevent="checkPreviewAccess")
            v-text-field(
              v-model="previewToken"
              label="Código de Acceso"
              outlined
              :append-icon="showToken ? 'mdi-eye-off' : 'mdi-eye'"
              :type="showToken ? 'text' : 'password'"
              @click:append="showToken = !showToken"
              :loading="loading"
              :disabled="loading"
              hide-details
              class="mb-4"
            )
            
            v-btn.px-6(
              color="primary"
              type="submit"
              :loading="loading"
              :disabled="!previewToken"
              elevation="2"
              large
            ) Verificar Acceso
</template>

<script>
export default {
  name: 'MaintenancePage',
  
  data: () => ({
    previewToken: '',
    showToken: false,
    loading: false,
    hasAccess: false
  }),

  methods: {
    async checkPreviewAccess() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('siteConfig/checkPreviewToken', this.previewToken);
        if (response.success) {
          // Guardar el token y navegar usando el router
          localStorage.setItem('preview_token', this.previewToken);
          this.$router.push('/');
        } else {
          this.$store.dispatch('showError', response.message || 'Código de acceso inválido');
        }
      } catch (error) {
        this.$store.dispatch('showError', 'Error al verificar el código de acceso');
      } finally {
        this.loading = false;
      }
    },

    async checkExistingAccess() {
      const token = this.$route.query.preview || localStorage.getItem('preview_token');
      if (token) {
        this.loading = true;
        try {
          const status = await this.$store.dispatch('siteConfig/checkMaintenanceStatus', token);
          if (status.hasAccess) {
            // Si tiene acceso, navegar a la página principal
            this.$router.push('/');
          }
        } catch (error) {
          console.error('Error al verificar acceso:', error);
          // Limpiar token inválido
          localStorage.removeItem('preview_token');
        } finally {
          this.loading = false;
        }
      }
    }
  },

  async created() {
    await this.checkExistingAccess();
  }
}
</script>

<style scoped>
.maintenance-page {
  min-height: 100vh;
  background: linear-gradient(135deg, var(--v-primary-base) 0%, var(--v-secondary-base) 100%);

  .maintenance-card {
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  }

  .v-text-field {
    max-width: 300px;
    margin: 0 auto;
  }

  h1 {
    font-family: 'Raleway', sans-serif;
    letter-spacing: 0.5px;
  }

  p {
    color: #666;
    line-height: 1.6;
  }
}
</style>
